import { createSelector } from 'reselect';
import CarrierPaperFreeMonitoringSummaryColumns
  from '../../containers/CarrierPaperFreeMonitoringSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, state => state.userData.userType, CarrierPaperFreeMonitoringSummaryColumns);
